export function getPaymentAmount(expressModel) {
  var _expressModel$payNow;
  return ((_expressModel$payNow = expressModel.payNow) == null ? void 0 : _expressModel$payNow.amount) || /* istanbul ignore next */'0';
}
//# sourceMappingURL=getPaymentAmount.js.map